import React, { useEffect, useState } from 'react';
// @ts-ignore
import moment, { Moment } from 'moment';
import Calendar from './Calendar';
import apiClient from '../../Services/ApiClient';
import Form from '../Form/Form';
import FormControl from '../Form/FormControl';
import { useEffectAsync } from '../../helpers';
import { WORKPLACES } from '../../Modules/Workplace/Graphql/workplaces.graphql';
// @ts-ignore
import styles from './AllWorkplacesCalendar.module.scss';
import { useAppContext } from '../../Services/AppContext';
import CalendarAbsenceEventModal from './CalendarAbsenceEventModal';
import Select from '../Base/Select/Select';
import useCalendarEvent from '../../Modules/Calendar/Hooks/useCalendarEvent';
import useTranslation from '../../Hooks/useTranslation';
import useWorkplaceEvents from '../../Modules/Events/Hooks/useWorkplaceEvents';
import { getMomentDate } from '../../Utils/dates.util';

interface AbsenceCalendarProps {
	loggedUserId?: string;
}

export default function AbsenceCalendar(props: AbsenceCalendarProps) {
	const { loggedUserId } = props;
	const { translation, workplaceId } = useAppContext();
	const { t } = useTranslation();
	const { renderAbsenceEvent } = useCalendarEvent();

	const [detailOpened, setDetailOpened] = useState(false);
	const [selectedDate, setSelectedDate] = useState(null);
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [dateRange, setDateRange] = useState({ start: null, end: null });
	const [events, setEvents] = useState<any[]>([]);
	const [selectedWorkplaceId, setSelectedWorkplaceId] = useState(null);
	const [loadingEvents, setLoadingEvents] = useState(false);
	const [resources, setResources] = useState([]);
	const [workplaces, setWorkplaces] = useState([]);
	const [workplacesIds, setWorkplacesIds] = useState([]);
	const [defaultValues, setDefaultValues] = useState({});
	const [initialized, setInitialized] = useState(false);

	const { getWorkersAbsenceEvents } = useWorkplaceEvents();

	// @ts-ignore

	useEffectAsync(async () => {
		await setInitialized(false);
		await setInitialized(true);
	}, [defaultValues]);

	// @ts-ignore
	useEffectAsync(async () => {
		await handleLoadResources();
	}, []);

	useEffect(() => {
		handleSetResources();
	}, [workplacesIds]);

	useEffect(() => {
		handleSetResources();
	}, [workplaces]);

	// @ts-ignore
	useEffectAsync(async () => {
		setLoadingEvents(true);
		await handleLoadData();
	}, [dateRange, resources]);

	useEffect(() => {
		setLoadingEvents(false);
	}, [events]);

	const handleSetResources = () => {
		if (!workplacesIds.length) {
			setWorkplacesIds([workplaceId]);
		}
		setResources(workplaces.filter(w => workplacesIds.indexOf(w.id) !== -1));
	};

	const handlePickDate = (date, resourceId = null) => {
		setSelectedDate(date);
		setSelectedWorkplaceId(resourceId);
		setDetailOpened(true);
	};

	const handleEventClick = event => {
		setSelectedEvent(event);
		setSelectedWorkplaceId(event.event.extendedProps.workplaceId);
		setDetailOpened(true);
	};

	const handleDateChange = (start: Moment, end?: Moment) => {
		setDateRange({ start, end });
	};

	// @ts-ignore
	const handleClose = async () => {
		setSelectedEvent(null);
		setDetailOpened(false);
		await handleLoadData();
	};

	const handleLoadData = () => {
		if (!dateRange.start || !resources.length) {
			setEvents([]);
			return;
		}

		// @ts-ignore
		const a = async () => {
			const events = await getWorkersAbsenceEvents({
				dateFrom: getMomentDate(dateRange.start),
				dateTo: getMomentDate(dateRange.end),
				workplaceIds: resources.map((r: any) => r.id),
			});
			setEvents(events);
		};

		a();
	};

	const handleEventDrop = event => {
		let workplaceId;
		for (const resource of event.getResources()) {
			workplaceId = resource.id;
		}

		// @ts-ignore
		const a = async () => {
			await apiClient.patch(`/event/${event.id}`, {
				dateFrom: moment(event.start).format(),
				dateTo: moment(event.end).format(),
				propIgnoreFreeTimeCheck: true,
				workplaceId,
			});
		};

		a();
	};

	// @ts-ignore
	const handleLoadResources = async () => {
		const tempWorkplaces = [];

		const { meta, data } = await apiClient.graphql({
			query: WORKPLACES,
			variables: {
				type: 'normal',
			},
			fetchPolicy: 'network-only',
		});

		for (const workplace of data.workplaces.data || []) {
			const item = {
				id: workplace.id,
				value: workplace.id,
				title: workplace.doctorDisplayName,
				label: workplace.doctorDisplayName,
				businessHours: [],
			};

			tempWorkplaces.push(item);

			if (workplace.id === workplaceId) {
				setDefaultValues({
					workplace: {
						value: workplace.id,
						label: workplace.doctorDisplayName,
					},
				});
			}
		}

		setWorkplaces(tempWorkplaces);
	};

	// @ts-ignore
	const handleSelectWorkplaces = async values => {
		setWorkplacesIds([values.id]);
	};

	return (
		initialized && (
			<div className={styles.wrapper}>
				<div className={styles.selectWrapper}>
					<Form defaultValues={defaultValues}>
						<FormControl
							name='workplace'
							onChange={handleSelectWorkplaces}
							isRequired={true}>
							<Select
								options={workplaces}
								isSearchable={true}
								placeholder={translation['base.chooseWorkplace']}
							/>
						</FormControl>
					</Form>
				</div>
				<div className={styles.calendarWrapper}>
					<Calendar
						events={events}
						onTimeClick={handlePickDate}
						onEventClick={handleEventClick}
						initialView={'timeGridWeek'}
						onDateChange={handleDateChange}
						editable={true}
						onEventDrop={handleEventDrop}
						onEventResize={handleEventDrop}
						resources={resources}
						loadingEvents={loadingEvents}
						renderEventItem={renderAbsenceEvent}
					/>
					<CalendarAbsenceEventModal
						opened={detailOpened}
						onClose={handleClose}
						selectedDate={selectedDate}
						defaultData={selectedEvent}
						loggedUserId={loggedUserId}
					/>
				</div>
			</div>
		)
	);
}
